// New translations for registration and email confirmation
const newTranslations = {
    // Registration and auth
    'registracija_sekme': 'Registreerimine õnnestus!',
    'vardas': 'Eesnimi',
    'pavarde': 'Perekonnanimi',
    'ivestiVarda': 'Sisesta eesnimi',
    'ivestiPavarde': 'Sisesta perekonnanimi',
    'slaptazodzio_keitimas': 'Parooli muutmine',
    'current_password': 'Praegune parool',
    'neteisingas_dabartinis_slaptazodis': 'Vale praegune parool',
    'profilis_atnaujintas': 'Profiil edukalt uuendatud!',
    'keisti_slaptazodi': 'Muuda',
    'slaptazodzio_keitimo_aprasymas': 'Saadame parooli muutmise lingi',
    'slaptazodzio_keitimo_nuoroda_issiusta': 'Parooli muutmise link on saadetud',
    'registracijos_klaida': 'Selle e-postiga kasutaja on juba registreeritud või kinnitamata',
    'sistemos_klaida': 'Ilmnes süsteemi viga. Palun proovige hiljem uuesti.',
    'registruojama': 'Registreerimine...',
    'privalomi_laukai': 'Palun täitke kõik kohustuslikud väljad',
    'prisijungimo_klaida': 'Sisselogimine ebaõnnestus. Teie konto pole administraatori poolt kinnitatud või kontrollige oma e-posti ja parooli.',
    'jungiamasi': 'Ühendamine...',
    'user_exists': 'Selle e-postiga kasutaja on juba registreeritud või kinnitamata',
    'esu_organizacijos_atstovas': 'Olen volitatud organisatsiooni esindaja ja saan luua konto organisatsiooni nimel',
    
    // Email confirmation
    'email_patvirtinimas': 'E-posti kinnitamine',
    'tikrinamas_email': 'E-posti kinnituse kontrollimine...',
    'email_patvirtintas': 'Teie e-post on edukalt kinnitatud!',
    'email_patvirtintas_sekmes': 'E-post edukalt kinnitatud! Nüüd peab administraator teie konto kinnitama.',
    'email_patvirtintas_admin': 'Administraator peab teie konto kinnitama enne, kui saate süsteemi kasutada. See võib võtta kuni 24 tundi.',
    'patvirtinimo_klaida': 'E-posti kinnitamisel ilmnes viga.',
    'truksta_parametru': 'Puuduvad vajalikud kinnitusparameetrid.',
    'netinkamas_patvirtinimo_tipas': 'Vale kinnituse tüüp. Palun proovige uuesti.',
    'grizti_i_prisijungima': 'Tagasi sisselogimise lehele',
    
    // Admin confirmation
    'laukiama_admin_patvirtinimo': 'Teie konto ootab administraatori kinnitust',
    'jūsų_paskyra_laukia_administratoriaus_patvirtinimo': 'Teie e-post on edukalt kinnitatud, kuid enne süsteemi kasutamist peab administraator teie konto kinnitama.',
    'gauti_patvirtinimą_gali_užtrukti_iki_24_val': 'Kinnitusprotsess võib võtta kuni 24 tundi. Saate e-posti teavituse, kui teie konto on kinnitatud.',
    'account_not_confirmed_by_admin': 'Administraator pole teie kontot veel kinnitanud. Saate süsteemi kasutada pärast seda, kui administraator on teie konto kinnitanud.',
    
    // Admin guide
    'vartotojų_patvirtinimas': 'Kasutaja kinnitamine',
    'nauji_vartotojai_turi_būti_patvirtinti_prieš_naudojimą': 'Uued kasutajad peavad olema kinnitatud enne süsteemi kasutamist.',
    'patvirtinti_vartotojai_gali_prisijungti_ir_naudotis_sistema': 'Kinnitatud kasutajad saavad sisse logida ja süsteemi kasutada.',
    'nepatvirtinti_vartotojai_negali_prisijungti': 'Kinnitamata kasutajad ei saa süsteemi täielikult kasutada.',
    'vartotojai_kurių_el_paštas_nepatvirtintas_gali_neturėti_prieigos': 'Kinnitamata e-postiga kasutajatel võib puududa juurdepääs süsteemile.',
    
    // Registration success
    'registration_success_email_confirmation': 'Registreerimine õnnestus! Kontrollige oma e-posti konto kinnitamiseks.',
    
    // Company confirmation
    'patvirtinti_imone': 'Kinnita ettevõte',
    'Vartotojas sėkmingai patvirtintas': 'Ettevõte edukalt kinnitatud!',
    'Klaida patvirtinant vartotoją': 'Viga ettevõtte kinnitamisel. Palun proovige uuesti.',

    // Subscription
    'galioja_iki': 'Kehtib kuni',
    'galiojanti': 'Kehtiv',
    'negaliojanti': 'Kehtetu',
    'prenumeratos_info': 'Valige tellimuse tüüp ja salvestage muudatused',
    'Įmonė sėkmingai patvirtinta!': 'Ettevõte edukalt kinnitatud!',
    'Metai pridėti. Nepamirškite paspausti "Išsaugoti" mygtuką, kad pakeitimai būtų išsaugoti.': 'Aastad lisatud. Ärge unustage muudatuste salvestamiseks klõpsata nuppu "Salvesta".',
    'login_error': 'Parool on vale või konto pole kinnitatud',
    'db_migration_info': 'Kui te pole veel oma parooli muutnud, klõpsake "Unustasin parooli" ja saadame teile parooli muutmise lingi. Andmebaas migreeriti teistesse serveritesse, seega peate looma uue parooli.',

    // Forgot password
    'forgotPass.invalidEmail': 'Vale e-posti formaat',
    'forgotPass.resetLinkSent': 'Parooli taastamise link on saadetud',
    'forgotPass.resetError': 'Viga taastamise lingi saatmisel',

    // OTP verification
    'send_code': 'Saada kood',
    'verify_code': 'Kinnita kood',
    'resend_code': 'Saada kood uuesti',
    'resend_code_in': 'Koodi saab uuesti saata',
    'otp_sent': 'Kinnituskood on saadetud!',
    'otp_resent': 'Uus kood on saadetud!',
    'invalid_otp': 'Vale kood. Proovige uuesti.',
    'verification_code': 'Kinnituskood',
    'otp_verification_desc': 'Sisestage saadud 6-kohaline kood',
    'enter_6_digit_code': 'Sisestage 6-kohaline kood'
};

export default newTranslations;
